import React from 'react';
import { complianceItems } from '../data/site';
export function Compliance() {
  return <section id="compliance" aria-labelledby="compliance-heading" className="border-t border-line" data-id="element-38" data-mp="1yfnod7euxgab">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-20 lg:px-16 lg:py-24" data-id="element-39" data-mp="1kfwenivdim24">
        <h2 id="compliance-heading" className="max-w-[620px] text-[32px] font-extrabold leading-tight tracking-tightest text-heading" data-id="element-40" data-mp="1peg4vvh02k0a">
          Homologation evidence, generated as you operate
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-41" data-mp="2i23ksx7bsmgl">
          {complianceItems.map(item => <article key={item.code} className="flex flex-col border-t border-line pt-5" data-id="element-42" data-mp="23dpjiqpk5625">
              <p className="font-mono text-sm font-medium text-accent-ink" data-id="element-43" data-mp="28c0skz813cjb">{item.code}</p>
              <h3 className="mt-3 text-base font-bold text-heading" data-id="element-44" data-mp="2w1v33a4vkp0e">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-45" data-mp="30twcmoans1mq">{item.description}</p>
            </article>)}
        </div>
      </div>
    </section>;
}